<figure class="__figure">
  <img [attr.src]="'assets/img/team/' + src">
</figure>
